import { Box, Popover, Typography } from '@atgfr8/atg-ui-tailwind';
import { createSignal, JSX } from 'solid-js';

type Props = {
  id: string;
  title: string;
  body: string;
  children: JSX.Element;
  horizontal?: number | 'right' | 'left' | 'center';
  htmlColor?: string;
};

export const OnHoverPopover = (props: Props) => {
  const [anchorEl, setAnchorEl] = createSignal<HTMLDivElement | undefined>();
  const [open, setOpen] = createSignal(false);

  const handlePopoverOpen = () => {
    setOpen(true);
  };

  const handlePopoverClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box
        // fontSize={12}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        ref={setAnchorEl}
        aria-haspopup="true"
        aria-owns={open() ? props.id : undefined}
        style={{
          'font-size': '12px',
          'overflow-wrap': 'anywhere',
          'white-space': 'pre-wrap',
        }}
      >
        {props.children}
      </Box>
      <Popover
        id={props.id}
        sx={{ 'pointer-events': 'none' }}
        open={open()}
        anchorEl={anchorEl()}
        dataTestId={`on-hover-popover-${props.id}`}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: props.horizontal ?? 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: props.horizontal ?? 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box p="8px">
          <Typography
            style={{
              'overflow-wrap': 'break-word',
              'max-width': '800px',
              'font-weight': 800,
            }}
          >
            {props.title}
          </Typography>
          <Typography
            style={{
              'overflow-wrap': 'break-word',
              'max-width': '800px',
            }}
          >
            {props.body}
          </Typography>
        </Box>
      </Popover>
    </div>
  );
};
